import { Injectable } from '@angular/core';

import { ApiClientProvider } from '../../../data-access';
import { CitiesApiClient } from './cities-api.client';
import { CitiesInMemoryApiClient } from './cities.api.inmemory.client';
import { ICitiesApiClient } from './i-cities-api.client';

@Injectable({
  providedIn: 'root'
})
export class CitiesApiClientProvider extends ApiClientProvider<ICitiesApiClient> {
  constructor(
    private client: CitiesApiClient,
    private inMemoryClient: CitiesInMemoryApiClient
  ) {
    super();
  }

  protected override getInMemoryClient(): ICitiesApiClient {
    return this.inMemoryClient;
  }
  protected override getApiClient(): ICitiesApiClient {
    return this.client;
  }
}
